exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#descripPOS{margin-top:400px}#cardDialog{background-color:#000}#dialog{overflow:hidden;background:none!important;-webkit-box-shadow:none;box-shadow:none}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-678a6026","scoped":false,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/player/StreamWait.vue
// module id = 627
// module chunks = 0